var checkDecimals = function (val, maxDecimals) {
    if (!val)
        return true;
    var splitValueDot = val.toString().split(".");
    if (splitValueDot.length > 2)
        return false;
    var decimals = splitValueDot.length === 1 ? 0 : splitValueDot[1].length;
    return decimals <= maxDecimals;
};

export { checkDecimals };
